/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { PropertyRequest } from '../model/models';
import { PropertyResource } from '../model/models';
import { PropertyStatusRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PropertyServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create property
     * 
     * @param propertyRequest 
     */
    createProperty(propertyRequest: PropertyRequest, extraHttpRequestParams?: any): Observable<PropertyResource>;

    /**
     * Delete property
     * 
     * @param property The property ID
     */
    deleteProperty(property: number, extraHttpRequestParams?: any): Observable<Array<any>>;

    /**
     * List properties
     * Filter by &#x60;type&#x60;, &#x60;status&#x60;, &#x60;userId&#x60;, &#x60;externalUserId&#x60;. Example &#x60;/properties?filter[type]&#x3D;1&#x60;
     * @param perPage 
     * @param page 
     */
    getProperties(perPage?: string, page?: string, extraHttpRequestParams?: any): Observable<Array<PropertyResource>>;

    /**
     * Show property
     * 
     * @param property The property ID
     */
    getProperty(property: number, extraHttpRequestParams?: any): Observable<PropertyResource>;

    /**
     * Show property pdf
     * 
     * @param property The property ID
     */
    getPropertyPdf(property: number, extraHttpRequestParams?: any): Observable<object>;

    /**
     * Show pdf
     * 
     * @param property The property ID
     */
    getPublicPropertyPdf(property: number, extraHttpRequestParams?: any): Observable<object>;

    /**
     * Get user properties
     * 
     * @param userId 
     */
    getUserProperties(userId?: string, extraHttpRequestParams?: any): Observable<Array<PropertyResource>>;

    /**
     * Update property
     * 
     * @param property The property ID
     * @param propertyRequest 
     */
    updateProperty(property: number, propertyRequest: PropertyRequest, extraHttpRequestParams?: any): Observable<PropertyResource>;

    /**
     * Update status
     * 
     * @param property The property ID
     * @param propertyStatusRequest 
     */
    updatePropertyStatus(property: number, propertyStatusRequest: PropertyStatusRequest, extraHttpRequestParams?: any): Observable<PropertyResource>;

}
